<template>
  <v-container fluid grid-list-lg>
    

    <v-layout row wrap v-if="error || success">
      <v-flex xs12 sm4 offset-sm4 pt-5>
        <v-alert  :value="true"  v-if="error != null" type="error" >{{ error.message }}</v-alert>
        <v-alert  :value="true"  v-if="success != null" type="success" >{{ success.message }}</v-alert>
      </v-flex>
    </v-layout>

    <v-layout row wrap v-if="loading">
      <v-flex xs12 sm4 offset-sm4 pt-5>
        <div class="loadingImage">
          <img src="../assets/loading.svg" height="88" width="88" class="loading" />
        </div>
      </v-flex>
    </v-layout>

    <v-layout row wrap v-if="!client_ref_no && !loading">
      <v-flex xs12 sm4 offset-sm4 pt-5>

        

        <v-layout justify-center column>
          <v-form ref="form" v-model="linkValid" validation @submit="linkAccount">
            
            <v-layout row>
              <v-flex xs12 pt-0 pb-4>
                <h3>I already have a {{configStrings.clubIdentifierName}}</h3>
                  </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12 pt-0 pb-4>
                <p class="notice">If you don't have an existing {{configStrings.clubIdentifierName}} please enter it below in order to link it to your {{configStrings.productName}} account.</p>
             </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex xs12>
                <v-text-field outline v-model="tmid" :rules="passRules" label="Enter your existing Client reference" type="text" required ></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout row align-center mx-1>
              <v-spacer />
              <button type="submit" class="button" :disabled="!linkValid">Link {{configStrings.clubIdentifierName}}</button>
            </v-layout>

          </v-form>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout row wrap v-if="!client_ref_no && !loading">
      <v-flex xs12 sm4 offset-sm4 pt-5>

    

        <v-layout justify-center column>
          <v-form ref="form" v-model="valid" lazy-validation @submit="createAccount">
            <v-layout row>
              <v-flex xs12 pt-0 pb-4>
                <h3>I don't have a {{configStrings.clubIdentifierName}}</h3>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12 pt-0 pb-4>
               <p class="notice">If you don't have an existing {{configStrings.clubIdentifierName}} you can generate one using the button below.</p>
             </v-flex>
            </v-layout>
            <v-layout row align-center mx-1>
              <v-spacer />
              <button type="submit" class="button" :disabled="!this.valid">Create New {{configStrings.clubIdentifierName}}</button>
            </v-layout>
          </v-form>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout row wrap v-else-if="!loading">
      <v-flex xs12 sm4 offset-sm4 pt-5>
        <v-layout justify-center column>
          <v-form ref="form" v-model="valid" lazy-validation @submit="unlinkAccount">
            
            <v-layout row>
              <v-flex xs12 pt-0 pb-4>
                <p class="notice">Your account is currently linked to the Client Reference <strong>{{client_ref_no}}</strong>.</p>
                  </v-flex>
            </v-layout>

            <v-layout row align-center mx-1>
              <v-spacer />
              <button type="submit" class="button" :disabled="!valid">Unlink {{configStrings.clubIdentifierName}}</button>
            </v-layout>

          </v-form>
        </v-layout>
      </v-flex>
      
      <v-flex xs12 sm4 offset-sm4 pt-5 v-if="showTicketingLink && !loading">

        <v-layout justify-center column>
          <v-form ref="form" v-model="valid" lazy-validation @submit="visitTicketingSite">
            
            <v-layout row align-center mx-1>
              <v-spacer />
              <button type="submit" class="button">Visit ticketing site</button>
            </v-layout>

          </v-form>
        </v-layout>
      </v-flex>

      <v-flex xs12 sm4 offset-sm4 pt-5 v-if="debugMode && !loading">

        <v-layout justify-center column>
          <v-form ref="form" v-model="valid" lazy-validation @submit="generateTicketingLink">
            
            <v-layout row align-center mx-1>
              <v-spacer />
              <button type="submit" class="button">Generate Ticketing site link</button>
            </v-layout>
            <p>Link: </p>
            <textarea rows="6" cols="100" v-model="generatedLink" ></textarea>
            
          </v-form>
        </v-layout>
      </v-flex>
      
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'UserProfileTicketmasterLink',
  data () {
    
    return {
      linkValid: true,
      valid:true,
      passRules: [
        v => !!v || this.configStrings.clubIdentifierName + ' is required',
        v => (v && v.length >= 1) || this.configStrings.clubIdentifierName + ' must be at least 1 character',
      ],
      tmid: '',
      newPassword: '',
      error: null,
      success: null,
      loading: false,
      createLoading: false,
      unlinkLoading: false,
      linkLoading: false,
      generateLoading: false,
      client_ref_no: null,
      showTicketingLink: false,
      debugMode: false,
      generatedLink: ''
    }
  },
  mounted () {
    if(this.$getAuthenticatedUser() == null){
      console.log('User is not logged in')
      this.$router.push("/");
    } else {
      this.$getCurrentUserAttributes().subscribe((userData) => {
        if(userData['custom:client_ref_verified'] === 'true'){
          console.log('user account is linked')
          this.client_ref_no = userData['custom:client_ref_no']
        } else {
          console.log('user account is not yet linked')
        }
      })
    }
    this.showTicketingLink = this.configValues.ticketMasterShowButton 
    this.debugMode = this.configValues.ticketMasterDebugMode
  },
  created () {
  },
  methods: {
    createAccount (e) {
      // TODO
      e.preventDefault()
        this.loading = true
        console.log('CREATING')
        this.ticketMasterCreate()
        .then((response) => {
            console.log('Create response', response)
            this.success = response
            this.error = null
            this.loading = false
            this.refreshPage()
        }, 
        (err)=> {
            //if we get an UnkownError it is more than likely because the user has a status of 'FORCE_CHANGE_PASSWORD' in AWS Cognito
            console.log(err);
            this.success = null
            this.error = err
            this.loading = false
        });   
    },
    generateTicketingLink (e) {
      e.preventDefault()
      this.loading = true
      this.ticketMasterGenerateToken(false).then((generatedUrl) => {
        console.log('Generated URL', generatedUrl)
        this.loading = false
        this.generatedLink = generatedUrl
      })
    },
    linkAccount (e) {
      e.preventDefault()
        this.loading = true
        console.log('LINKING')
        this.ticketMasterLink(this.tmid)
        .then((response) => {
            console.log('Link response', response)
            if (response.success == false) { 
              this.success = null
               this.error = response
               this.loading = false
            } else {
              this.success = response
              this.error = null
              this.loading = false
              this.refreshPage()
            }
            
        }, 
        (err)=> {
            //if we get an UnkownError it is more than likely because the user has a status of 'FORCE_CHANGE_PASSWORD' in AWS Cognito
            console.log(err);
            this.success = null
            this.loading = false
            this.error = err
        });    
    },
    unlinkAccount (e) {
        e.preventDefault()
        this.loading = true
        
        this.ticketMasterUnlink()
        .then((response) => {
            console.log('Unlink response', response)
            if (response.success == false) { 
              this.success = null
               this.error = response
               this.loading = false
               //TODO Refresh tokens here
            } else {
              this.success = response
              this.loading = false
              this.error = null
              this.refreshPage()
            }
        }, 
        (err)=> {
            //if we get an UnkownError it is more than likely because the user has a status of 'FORCE_CHANGE_PASSWORD' in AWS Cognito
            console.log(err);
            this.loading = false
            this.success = null
            this.error = err
        });    
    }, 
    refreshPage (){
      this.$getCurrentUserAttributesWithRefresh().subscribe( userData => {
      //this.$getCurrentUserAttributes().subscribe((userData) => {

        console.log("Session data refreshed", userData);
        if(userData['custom:client_ref_verified'] === 'true'){
          console.log('user account is linked')
          this.client_ref_no = userData['custom:client_ref_no']
        } else {
          console.log('user account is not linked')
          this.client_ref_no = null
        }
          //this.tmid = 
      })
    },
    visitTicketingSite (e) {
      e.preventDefault()
      this.ticketMasterRedirectWithToken()
    }
  }
}
</script>

<style scoped>
  .loadingImage img {
      display:block;
      margin:auto;
  }
</style>